import About from '@/sections/home/about';
import Contact from '@/sections/home/contact';
import Hero from '@/sections/home/hero';
import Services from '@/sections/home/services';
import SEO from '@/components/seo';
import type React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Home: React.FC = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        const home = document.querySelector('#home');
        if (home) home.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.hash]);

  // Structured Data voor LocalBusiness
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Praktijk Iselda',
    description: 'Praktijk voor EFT relatietherapie, systeemtherapie en gezinstherapie',
    image: 'https://www.iselda.nl/images/iselda-og-image.jpg',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'NL'
    },
    priceRange: '€€',
    telephone: '',
    url: 'https://www.iselda.nl',
    sameAs: ['https://www.linkedin.com/company/praktijk-iselda/'],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Therapie diensten',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'EFT Relatietherapie',
            description: 'Emotionally Focused Therapy voor koppels'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Systeemtherapie',
            description: 'Therapie voor gezinnen en families'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Individuele therapie',
            description: 'Persoonlijke begeleiding en therapie'
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Praktijk Iselda - EFT Relatietherapie & Systeemtherapie"
        description="Welkom bij Praktijk Iselda. Specialist in EFT (Emotionally Focused Therapy) voor relaties. Professionele relatietherapie, gezinstherapie en individuele begeleiding door Iselda, erkend systeemtherapeut."
        keywords="Praktijk Iselda, Iselda, Iselda Waasdijk, EFT, EFT therapie, emotionally focused therapy, relatietherapie, systeemtherapie, gezinstherapie, relatietherapeut, NVRG therapeut, therapie praktijk"
        structuredData={structuredData}
      />
      <section
        id="home"
        className="md:snap-start flex items-start justify-center bg-hero p-4 md:p-8 pt-8 md:pb-24"
      >
        <Hero />
      </section>

      <section
        id="over"
        className="md:snap-start flex items-center justify-center bg-athens-gray-200 py-12 p-4 fade-in"
      >
        <About />
      </section>

      <section
        id="aanbod"
        className="md:snap-start flex items-center justify-center bg-athens-gray-100 py-24 p-4 fade-in"
      >
        <Services />
      </section>

      {/*<section*/}
      {/*  id="testimonials"*/}
      {/*  className="md:snap-start flex items-center justify-center bg-typography py-24 p-4 fade-in"*/}
      {/*>*/}
      {/*  <TestimonialSlider />*/}
      {/*</section>*/}

      <section
        id="contact"
        className="md:snap-start flex items-center justify-center bg-section-primary py-24 p-4"
      >
        <Contact />
      </section>
    </>
  );
};

export default Home;
